(() => {
  const menus=[...document.querySelectorAll('.trevi-learn-menu')];
  menus.forEach(menu=>menu.addEventListener('toggle',()=>{
    if(menu.open)document.querySelectorAll('.trevi-shop-menu[open],.trevi-learn-menu[open]').forEach(other=>{if(other!==menu)other.open=false;});
    menu.querySelectorAll('video').forEach(video=>{
      if(menu.open){if(!video.src)video.src=video.dataset.learnSrc;if(!matchMedia('(prefers-reduced-motion:reduce)').matches)video.play().catch(()=>{});}else video.pause();
    });
  }));
  document.querySelectorAll('.trevi-shop-menu').forEach(shop=>shop.addEventListener('toggle',()=>{if(shop.open)menus.forEach(menu=>menu.open=false);}));
  document.addEventListener('click',event=>menus.forEach(menu=>{if(menu.open&&!menu.contains(event.target))menu.open=false;}));
  document.addEventListener('keydown',event=>{if(event.key==='Escape')menus.forEach(menu=>{if(menu.open){menu.open=false;menu.querySelector('summary').focus();}});});
})();
